export default __webpack_public_path__ + "static/10-packages-a58ad15883695888773e4599677f15c1.png";